import React from 'react';
import { numberHandler } from '../../../commonJS/addCommasToNumber';


const NamedField = (props) => (
  <div className='repair-named-field'>
    <div className='font-align-left'>
      <div className='font-size-8'>{props.title}</div>
    </div>
    <div style={props.contentStyle} className={(props.nameDist ? ('name-dist-' + props.nameDist) : null)}>
      {
        props.type === 'textarea' ?
          <textarea defaultValue={props.content} className={props.contentClassName ? ('font-size-10 ' + props.contentClassName) : 'font-size-10'} name="" id="" cols="30" rows="10" />
          :
          // 以下空白提示字串置中
          <div style={props.emptyString ? { textAlign: 'center' } : null} className={props.contentClassName ? ('font-size-10 ' + props.contentClassName) : 'font-size-10'}>
            {props.content}
          </div>
      }

      {
        props.ind !== undefined ? (<div className='font-size-8 cost-part-sequence font-align-center'>{props.ind}</div>) : null
      }
    </div>
  </div>
);

const CostPart = (props) => {
  const { languageData, languageCode } = window.myConsts,
    langCode = languageCode, langData = languageData;

  return (
    <div className="cost-part-container">
      <div className={props.drawBottom ? "inside-body-content-bottom-border inside-body-content" : "inside-body-content"}>
        <NamedField emptyString={props.partData.emptyString} ind={props.ind} title={props.showTitle ? langData['285'][langCode] : ""} content={props.partData.part_id} nameDist='' />
      </div>
      <div className={props.drawBottom ? "inside-body-content-bottom-border inside-body-content" : "inside-body-content"}>
        <NamedField title={props.showTitle ? langData['286'][langCode] : ""} content={props.partData.name} nameDist='' />
      </div>
      <div className={props.drawBottom ? "inside-body-content-bottom-border inside-body-content inside-body-content-half-width" : "inside-body-content inside-body-content-half-width"}>
        <div className="inside-body-content" style={{ borderTopWidth: 0, width: 109 }}>
          <NamedField title={props.showTitle ? langData['375'][langCode] : ""} content={props.partData.part_spec} nameDist='' />
        </div>
        <div className="inside-body-content" style={{ borderTopWidth: 0, width: 45 }}>
          <NamedField title={props.showTitle ? langData['332'][langCode] : ""} content={props.partData.qty} nameDist='' contentClassName="align-to-right" />
        </div>
        <div className="inside-body-content" style={{ borderTopWidth: 0, width: 45 }}>
          <NamedField title={props.showTitle ? langData['290'][langCode] : ""} content={props.partData.price} nameDist='' contentClassName="align-to-right" />
        </div>
        <div className="inside-body-content" style={{ borderTopWidth: 0, borderRight: 'none', width: 72 }}>
          <NamedField title={props.showTitle ? langData['376'][langCode] : ""} content={props.partData.total} nameDist='' contentClassName="align-to-right" />
        </div>
      </div>
    </div>
  );
};

const RepairPhotoBlock = (props) => (
  <div className='repair-pdf-photo-block'>
    <div className='repair-pdf-title-row'>
      <div className={props.classRotateText}>{props.title}</div>
    </div>
    <div className='pdf-photo-container'>
      {
        props.photos.map((photo, ind) => (
          <img key={'photo' + ind} className="pdf-photo" src={photo.file_name} alt='repair' />
        ))
      }
    </div>
  </div>
);


const RepairPdfContentPs = (props) => {
  // fake data
  // const costParts = [
  //   {part_id: 1, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 2, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 3, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 4, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 5, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 1, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 2, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 3, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 4, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 5, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 1, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 2, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 3, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 4, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 5, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 1, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 2, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 3, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 4, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 5, name: 1, part_spec: 1, qty: 3, price: 10, total: 30},
  //   {part_id: 5, name: 1, part_spec: 1, qty: 3, price: 10, total: 30}
  // ];


  const { languageData, languageCode } = window.myConsts,
    pdfType = props.pdfType, data = props.data,
    loginCompanyInfo = data.loginCompanyInfo,
    langCode = languageCode, langData = languageData;

  let len, costParts, tempParts,
    singlePageTotal = 0, headerClass, formTitle;

  // for photo page
  let upperTitle, lowerTitle, upperPhotos, lowerPhotos;

  switch (pdfType) {
    case 'main':
      formTitle = langData['403'][langCode]
      headerClass = "repair-pdf-main-page"
      costParts = props.data.parts;
      break;
    case 'partList':
      formTitle = langData['330'][langCode]
      headerClass = "repair-pdf-part-page"
      costParts = props.filteredPartsList;
      break;
    case 'photo':
      formTitle = langData['406'][langCode]
      headerClass = "repair-pdf-photo-page"

      if (props.issueFilteredPhotos) {
        upperTitle = lowerTitle = langData['165'][langCode];
        // 有傳入issueFilteredPhotos代表length介於5~8，否則會列在remaining
        upperPhotos = props.issueFilteredPhotos.slice(0, 4);
        // slice未給第二個參數會取到最後1個元素
        lowerPhotos = props.issueFilteredPhotos.slice(4);

      } else if (props.issueRemainingPhotos) {
        upperTitle = langData['165'][langCode];
        lowerTitle = langData['276'][langCode];

        // 有傳入issueRemainingPhotos代表length介於1~4
        upperPhotos = props.issueRemainingPhotos;
        // 有傳入issueRemainingPhotos代表傳入的repairFilteredPhotos介於0~4
        lowerPhotos = props.repairFilteredPhotos;
      } else {
        upperTitle = lowerTitle = langData['276'][langCode];
        // 純repairFilteredPhotos
        // slice第二個參數給定的索引若超出索引範圍，會自動取到最後1個有效索引
        upperPhotos = props.repairFilteredPhotos.slice(0, 4);
        // slice第一個參數給定的索引若超出索引範圍，會自動傳回空陣列
        lowerPhotos = props.repairFilteredPhotos.slice(4);
      }
      break;
    default:

  }

  if (pdfType === 'photo') {

  } else {
    len = costParts.length;
    tempParts = costParts.slice();
  }

  switch (pdfType) {
    case 'main':
      if (len > 5) {
        // 填充內容
        tempParts = [
          { noInd: true, part_id: langData['402'][langCode], name: '', part_spec: '', qty: '', price: '', total: data.subtotal },
          { part_id: '', name: '', part_spec: '', qty: '', price: '', total: '' },
          { part_id: '', name: '', part_spec: '', qty: '', price: '', total: '' },
          { part_id: '', name: '', part_spec: '', qty: '', price: '', total: '' },
          { part_id: '', name: '', part_spec: '', qty: '', price: '', total: '' },
        ];
      } else if (len !== 5) {
        // 填滿為5筆
        const numberToFill = 5 - len;
        for (let i = 0; i < numberToFill; i++) {
          tempParts.push({ part_id: '', name: '', part_spec: '', qty: '', price: '', total: '' });
        }
      }

      break;
    case 'partList':
      // 每頁最大23筆
      // 填滿前計算單頁合計金額
      for (let i = 0; i < len; i++) {
        singlePageTotal += tempParts[i].total * 1;
      }

      // 加上千分位
      singlePageTotal = numberHandler(singlePageTotal);

      // 填滿為23筆
      if (len < 23) {
        const numberToFill = 23 - len;

        // 第1筆填上/ 以下空白 /
        tempParts.push({ emptyString: true, noInd: true, part_id: langData['409'][langCode], name: '', part_spec: '', qty: '', price: '', total: '' });

        // 從索引1開始，因為索引0已填上/ 以下空白 /
        for (let i = 1; i < numberToFill; i++) {
          tempParts.push({ part_id: '', name: '', part_spec: '', qty: '', price: '', total: '' });
        }

      }
      break;
    case 'photo':

      break;
    default:

  }

  let dynamicContent;

  if (pdfType === 'photo') {
    dynamicContent = '';
  } else {
    dynamicContent = tempParts.map((item, ind) => {

      const newObj = { ...item },
        // 序號顯示判斷
        indToShow = (item.part_id && !item.noInd) ? ((props.startInd || 0) + ind + 1) : '';

      // part千分位處理
      newObj.qty = numberHandler(newObj.qty);
      newObj.price = numberHandler(newObj.price);
      newObj.total = numberHandler(newObj.total);

      // if(ind === 0) return <CostPart key={'costParts' + ind} ind={ind + 1} showTitle={true} partData={newObj} />
      // 清單情況下，5倍數畫底線，序號接續前頁
      if (pdfType === 'partList' && ((ind + 1) % 5 === 0)) return <CostPart key={'costParts' + ind} drawBottom={true} ind={indToShow} partData={newObj} />

      return <CostPart key={'costParts' + ind} ind={indToShow} partData={newObj} />
    });
  }

  // 側邊 title 中文以外的文字轉向
  const classRotateText = (langCode !== 'zh-tw' && langCode !== 'zh-cn') ? 'repair-side-title-rotate' : null;

  return (
    <div className='repair-pdf-content-container pdf-content-container'>
      {/* Header區開始 */}
      <div className={headerClass + ' repair-pdf-content-header'}>
        <div className='company-title-container'>
          <div>
            <span className='img-text-mixed-container'>
              <img src={loginCompanyInfo.companyLogo} alt="companyLogo"></img>
              <span>{loginCompanyInfo.companyTitle}</span>
            </span>
          </div>
          <div>
            <div className='font-size-8'>TEL： {loginCompanyInfo.companyTel} | FAX： {loginCompanyInfo.companyFax} | Email： {loginCompanyInfo.companyEmail}</div>
          </div>
          <div>
            <div className='font-size-8'>{loginCompanyInfo.companyAddress}</div>
          </div>
        </div>
        <div className="repair-form-title-container">
          <div><div className="font-align-left font-size-10">{langData['437'][langCode]}：<span style={{ color: "rgba(208, 2, 27, 1)" }}>{data.repair_id}</span></div></div>
          <div><div className="font-align-center font-size-12">{formTitle}</div></div>
          <div><div className="font-align-right font-size-10">{langData['414'][langCode]}：<span style={{ color: "rgba(208, 2, 27, 1)" }}>{data.job_number}</span></div></div>
        </div>
      </div>
      {/* Header區結束 */}
      {/* 主表區開始 */}
      {
        pdfType === 'main' ?
          <div>
            <div className='repair-pdf-content-body'>
              <div className='repair-pdf-content-body-1'>
                <div className='repair-pdf-content-body-title'>
                  <div className={classRotateText}>
                    {langData['294'][langCode]}
                  </div>
                </div>
                <div className='repair-pdf-content-body-content'>
                  {/* <div className="inside-body-content">
                      <NamedField title='表單類型' content={data.formTypeName} nameDist='' />
                    </div> */}
                  <div className="inside-body-content">
                    <NamedField title={langData['164'][langCode]} content={data.repair_date._i} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['366'][langCode]} content={data.areaTypeName} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['114'][langCode]} content={data.product_model ? data.product_model.name : ''} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['134'][langCode]} content={data.serial_number} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-three-quarters-width">
                    <NamedField title={langData['21'][langCode]} content={data.company.name} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['28'][langCode]} content={data.corp_vat_number} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['368'][langCode]} content={data.factoryName} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-half-width">
                    <NamedField title={langData['1'][langCode]} content={data.address} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['367'][langCode]} content={data.contractName} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-bottom-border">
                    <NamedField title={langData['33'][langCode]} content={data.contact ? data.contact.name : ''} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-bottom-border">
                    <NamedField title={langData['41'][langCode]} content={data.contact_phone} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-bottom-border">
                    <NamedField title={langData['146'][langCode]} content={data.contact_mobile} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-bottom-border">
                    <NamedField title={langData['61'][langCode]} content={data.contact_email} nameDist='' />
                  </div>
                  {/* <div className="inside-body-content inside-body-content-bottom-border">
                      <NamedField title='產品來源' content='' nameDist='' />
                    </div> */}
                </div>
              </div>
              <div className='repair-pdf-content-body-2'>
                <div className='repair-pdf-content-body-title'>
                  <div className={classRotateText}>
                    {langData['295'][langCode]}
                  </div>
                </div>
                <div className='repair-pdf-content-body-content'>
                  <div className="inside-body-content inside-body-content-full-width">
                    <NamedField title={langData['371'][langCode]} content={data.serviceTypeNames} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['274'][langCode]} content={data.assignedMenNames} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-three-quarters-width">
                    <NamedField title={langData['372'][langCode]} content={data.collaborator} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['275'][langCode]} content={data.assign_date ? (`${data.assign_date.format("YYYY-MM-DD")} ${data.assign_h}:${data.assign_m}`) : ""} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['373'][langCode]} content={data.departure_date ? (`${data.departure_date.format("YYYY-MM-DD")} ${data.departure_h}:${data.departure_m}`) : ""} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['296'][langCode]} content={data.arrive_date ? (`${data.arrive_date.format("YYYY-MM-DD")} ${data.arrive_h}:${data.arrive_m}`) : ""} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['297'][langCode]} content={data.leave_date ? (`${data.leave_date.format("YYYY-MM-DD")} ${data.leave_h}:${data.leave_m}`) : ""} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-half-width">
                    <NamedField title={langData['267'][langCode]} content={data.issueTypeNames} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-half-width">
                    <NamedField title={langData['374'][langCode]} content={data.judgeName} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-half-width repair-description inside-body-content-bottom-border">
                    <NamedField contentStyle={{ textAlign: 'left' }} title={langData['165'][langCode]} type="textarea" content={data.repair_content} nameDist='6' />
                  </div>
                  <div className="inside-body-content inside-body-content-half-width repair-description inside-body-content-bottom-border">
                    <NamedField contentStyle={{ textAlign: 'left' }} title={langData['276'][langCode]} type="textarea" content={data.maintain_content} nameDist='6' />
                  </div>
                </div>
              </div>
              <div className='repair-pdf-content-body-3'>
                <div className='repair-pdf-content-body-title'>
                  <div className={classRotateText}>
                    {langData['298'][langCode]}
                  </div>
                </div>
                <div className='repair-pdf-content-body-content'>
                  <CostPart showTitle={1} partData={{}} ind={langData['401'][langCode]} />
                  {dynamicContent}

                  <div className="inside-body-content">
                    <NamedField title={langData['381'][langCode]} content={data.receipt_number} nameDist='' />
                  </div>
                  <div className="inside-body-content">
                    <NamedField title={langData['382'][langCode]} content={data.receipt_title} nameDist='' />
                  </div>
                  <div className="inside-body-content inside-body-content-half-width">
                    <NamedField title={langData['377'][langCode]} content={numberHandler(data.working_cost)} nameDist='' contentClassName='align-to-right' />
                  </div>
                  <div className="inside-body-content inside-body-content-half-width inside-body-content-bottom-border repair-description">
                    <NamedField title={langData['68'][langCode]} content={data.remarks} type="textarea" nameDist='6' />
                  </div>
                  <div className="inside-body-content inside-body-content-half-width inside-body-content-bottom-border repair-description">
                    <div className="inside-body-content inside-body-content-full-width">
                      <NamedField title={langData['378'][langCode]} content={numberHandler(data.service_cost)} nameDist='' contentClassName='align-to-right' />
                    </div>
                    {/* <div className="inside-body-content inside-body-content-full-width">
                      <NamedField title='合計' content={numberHandler(data.subtotal)} nameDist='' contentClassName='align-to-right' />
                    </div> */}

                    <div className="inside-body-content inside-body-content-full-width">
                      <div className="inside-body-content" style={{ width: 80 }}>
                        <NamedField title={langData['415'][langCode]} content={numberHandler(data.discount)} nameDist='' contentClassName="align-to-right highlight-font-red" />
                      </div>
                      <div className="inside-body-content" style={{ width: 191 }}>
                        <NamedField title={langData['379'][langCode]} content={numberHandler(data.subtotal)} nameDist='' contentClassName='align-to-right' />
                      </div>
                    </div>

                    <div className="inside-body-content inside-body-content-full-width">
                      <NamedField title={langData['380'][langCode]} content={data.tax + '%'} nameDist='' contentClassName='align-to-right' />
                    </div>
                    <div className="inside-body-content inside-body-content-full-width">
                      <div className="inside-body-content" style={{ width: 80 }}>
                        <NamedField title={langData['288'][langCode]} content={data.currencyName} nameDist='' />
                      </div>
                      <div className="inside-body-content" style={{ width: 190.11 }}>
                        <NamedField title={langData['280'][langCode]} content={numberHandler(data.total_amount)} nameDist='' contentClassName='align-to-right' />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className='repair-pdf-content-footer'>
              <div className='rapair-footer-half-container left'>
                {/* <div className='inside-repair-footer'>
                  <NamedField title={langData['397'][langCode]} content='' nameDist='' contentClassName='font-align-center' />
                </div>
                <div className='inside-repair-footer'>
                  <NamedField title={langData['398'][langCode]} content='' nameDist='' contentClassName='font-align-center' />
                </div> */}
                <div className='inside-repair-footer'>
                  <NamedField title={langData['397'][langCode]}
                    content={data.signatureapprover_images[0] ? <img src={data.signatureapprover_images[0].file_name} alt='approver-signature' /> : ''}
                    nameDist='' contentClassName='cus-sign-photo' />
                </div>
                <div className='inside-repair-footer'>
                  <NamedField title={langData['398'][langCode]}
                    content={data.signaturemanager_images[0] ? <img src={data.signaturemanager_images[0].file_name} alt='manager-signature' /> : ''}
                    nameDist='' contentClassName='cus-sign-photo' />
                </div>
                <div className='inside-repair-footer'>
                  <NamedField title={langData['399'][langCode]} content={data.supervisor_review} nameDist='' contentClassName='font-align-center' />
                </div>

              </div>

              <div className='rapair-footer-half-container right'>
                <div className='inside-repair-footer'>
                  <NamedField title={langData['336'][langCode]}
                    content={data.signature_images[0] ? <img src={data.signature_images[0].file_name} alt='cus-signature' /> : ''}
                    nameDist='' contentClassName='cus-sign-photo' />
                </div>
                <div className='inside-repair-footer'>
                  <NamedField title={langData['383'][langCode]} content={data.satisfactionName} nameDist='' contentClassName='font-align-center' />
                </div>

              </div>
            </div>
          </div>
          :
          null
      }
      {/* 主表區結束 */}

      {/* 零件清單區開始 */}
      {
        pdfType === 'partList' ?
          <div>
            <div className='repair-pdf-content-body'>
              {/* <div className='repair-pdf-title-row'>
              <div className='font-size-10'>零件附表</div>
            </div> */}

              <div className='repair-pdf-content-body-3'>
                <div className='repair-pdf-content-body-content repair-part-list'>
                  <CostPart showTitle={1} partData={{}} ind="序號" />
                  {dynamicContent}
                </div>
              </div>
            </div>
            <div className='repair-pdf-content-footer-part-list'>
              <div className="inside-body-content inside-body-content-half-width">
                <NamedField title={langData['405'][langCode]} content={singlePageTotal} nameDist='' contentClassName='align-to-right' />
              </div>
            </div>
          </div>
          :
          null
      }
      {/* 零件清單區結束 */}

      {/* 圖片區開始 */}
      {
        pdfType === 'photo' ?
          <div>
            <div className='repair-pdf-content-body'>
              <RepairPhotoBlock classRotateText={classRotateText} title={upperTitle} photos={upperPhotos} />
              <RepairPhotoBlock classRotateText={classRotateText} title={lowerTitle} photos={lowerPhotos} />
            </div>
          </div>
          :
          null
      }
      {/* 圖片區結束 */}
    </div>
  );
};


export default RepairPdfContentPs;


// WEBPACK FOOTER //
// ./src/salesky/routes/online_repair/RepairPdfContentPs.jsx